import React, { useState } from 'react';
import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import TweetBox from './TweetBox';
import './PostModal.css';

/**
 * 投稿用のモーダルコンポーネント
 * @param {boolean} open - モーダルを開くかどうか
 * @param {function} onClose - モーダルを閉じる関数
 * @param {function} onPostSubmitted - 投稿完了時のコールバック関数
 */
function PostModal({ open, onClose, onPostSubmitted }) {
  // 投稿が追加されたときの処理
  const handlePostAdded = (newPost) => {
    // 投稿完了コールバックがあれば呼び出し
    if (onPostSubmitted) {
      onPostSubmitted(newPost);
    }
    // モーダルを閉じる
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="post-modal"
      PaperProps={{
        style: {
          borderRadius: '16px',
          overflow: 'hidden'
        }
      }}
    >
      <DialogTitle className="post-modal__header">
        <IconButton
          edge="start"
          color="inherit"
          onClick={onClose}
          aria-label="close"
          className="post-modal__close-button"
        >
          <CloseIcon />
        </IconButton>
        <span className="post-modal__title">新規投稿</span>
      </DialogTitle>
      <DialogContent className="post-modal__content">
        <TweetBox addPost={handlePostAdded} inModal={true} />
      </DialogContent>
    </Dialog>
  );
}

export default PostModal; 